import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/GroupGridCentreLowerLayout.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faVideoCamera,
  faMobile,
  faMessage,
  faUserPlus,
  faLock,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import "../../../Styles/ua-common-styles.css";
import "../../../../Styles/common-styles.css";

const UGGridCentreLowerLayout = ({
  groups = [],
  selectedGroups = [],
  onGroupSelect = () => {},
  renderOperation,
  setRenderOperation,
  activeTab = "current",
}) => {
  const navigate = useNavigate();

  const handleClick = (operationType, groupId, mode) => {
    setRenderOperation({
      operationType,
      data: { groupId },
      mode,
    });
  };

  // ✅ Handle join group (for suggested groups)
  const handleJoinGroup = (groupId) => {
    console.log("Joining group:", groupId);
    alert("Request sent to join group!");
  };

  // ✅ Handle checkbox change
  const handleCheckboxChange = (groupId) => {
    onGroupSelect(groupId);
  };

  // ✅ Format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  // ✅ Get member count
  const getMemberCount = (group) => {
    return group.nmembers || (group.members ? group.members.length : 0);
  };

  // ✅ Get message count
  const getMessageCount = (group) => {
    return group.totalmesg || (group.messages ? group.messages.length : 0);
  };

  // ✅ Check if user is admin
  const isUserAdmin = (group, userId) => {
    if (!group.members) return false;
    const userMember = group.members.find((m) => m.personid === userId);
    return userMember?.adminrights === "true" || userMember?.adminrights === true;
  };

  return (
    <div className="uag-central-container" style={{ gap: 15 }}>
      {groups.length === 0 ? (
        <div
          style={{
            gridColumn: "1 / -1",
            textAlign: "center",
            padding: "40px 20px",
            color: "rgba(255, 255, 255, 0.6)",
          }}
        >
          <p style={{ fontSize: 16, marginBottom: 10 }}>
            {activeTab === "current"
              ? "😢 You haven't joined any groups yet"
              : "✨ No suggested groups available"}
          </p>
          <p style={{ fontSize: 14, color: "rgba(255, 255, 255, 0.4)" }}>
            {activeTab === "current"
              ? "Discover and join groups to connect with people"
              : "Check back later for more suggestions"}
          </p>
        </div>
      ) : (
        groups.map((group) => (
          <div
            key={group.groupid}
            className="uag-profile-card"
            style={{
              display: "flex",
              flexDirection: "column",
              position: "relative",
              height: 300, 
              width: 250
            }}
          >
            {/* ✅ Selection Checkbox */}
            <div
              style={{
                position: "absolute",
                top: 10,
                left: 10,
                zIndex: 10,
              }}
            >
              <input
                type="checkbox"
                checked={selectedGroups.includes(group.groupid)}
                onChange={() => handleCheckboxChange(group.groupid)}
                style={{
                  width: 20,
                  height: 20,
                  cursor: "pointer",
                }}
              />
            </div>

            {/* ✅ Group Category Badge */}
            <div
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                zIndex: 10,
                background: "white",
                padding: "4px 8px",
                borderRadius: 4,
                display: "flex",
                alignItems: "center",
                gap: 4,
                fontSize: 11,
                color: "black",
                fontWeight: 600,
              }}
            >
              <FontAwesomeIcon
                icon={group.category === "private" ? faLock : faGlobe}
                size="xs"
              />
              {group.category === "private" ? "Private" : "Public"}
            </div>

            {/* ✅ Group Card Content */}
            <div className="ua-profile">
              <img
                src={group.grouppic}
                alt={group.groupid}
                className="ug-image"
                style={{
                  opacity: selectedGroups.includes(group.groupid) ? 0.6 : 1,
                  transition: "opacity 0.2s ease",
                }}
              />

              {/* ✅ Group Details */}
              <div className="ug-details">
                <p className="text-header" style={{ fontWeight: "bold" }}>
                  {group.groupid}
                </p>

                {/* Members and Messages Info */}
                <div
                  style={{
                    fontSize: 12,
                    color: "rgba(255, 255, 255, 0.6)",
                    display: "flex",
                    gap: 10,
                    justifyContent: "center",
                    marginTop: 5,
                  }}
                >
                  <span>👥 {getMemberCount(group)} members</span>
                  <span>💬 {getMessageCount(group)} messages</span>
                </div>

                {/* Created Info */}
                <div
                  style={{
                    fontSize: 11,
                    color: "rgba(255, 255, 255, 0.5)",
                    marginTop: 5,
                  }}
                >
                  Created by <strong>{group.createdby || "Admin"}</strong>
                  <br />
                  on {formatDate(group.createdOn)}
                </div>

                {/* Activity Level Badge */}
                {group.activelevel && (
                  <div
                    style={{
                      fontSize: 11,
                      marginTop: 8,
                      padding: "4px 8px",
                      borderRadius: 4,
                      background: "black",
                      color: "white",
                      fontWeight: 600,
                      textAlign: "center",
                    }}
                  >
                    Activity: {group.activelevel.toUpperCase()}
                  </div>
                )}
              </div>

              {/* ✅ Group Profile Actions */}
              <div className="ug-profile-action" style={{ marginTop: 50 }}>
                {activeTab === "current" ? (
                  <>
                    {/* Current Group Actions */}
                    <button
                      className="uag-action-btn"
                      onClick={() =>
                        window.location.href = `http://community.kleido.ai/group-page/sample/${group.groupid}`
                      }
                      title="Visit Group"
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </button>
                    <button
                      className="uag-action-btn"
                      onClick={() =>
                        handleClick("messaging", group.groupid, "group")
                      }
                      title="Message"
                    >
                      <FontAwesomeIcon
                        icon={faMessage}
                        style={{ color: "white" }}
                      />
                    </button>
                    <button
                      className="uag-action-btn"
                      onClick={() =>
                        handleClick("audio", group.groupid, "group")
                      }
                      title="Audio Call"
                    >
                      <FontAwesomeIcon icon={faMobile} />
                    </button>
                    <button
                      className="uag-action-btn"
                      onClick={() =>
                        handleClick("video", group.groupid, "group")
                      }
                      title="Video Call"
                    >
                      <FontAwesomeIcon icon={faVideoCamera} />
                    </button>
                  </>
                ) : (
                  <>
                    {/* Suggested Group Actions */}
                    <button
                      className="ug-action-btn"
                      onClick={() => handleJoinGroup(group.groupid)}
                      title="Join Group"
                      style={{
                        flex: 1,
                        background: "rgba(102, 126, 234, 0.3)",
                        border: "1px solid gray",
                        borderRadius: 6,
                        padding: "8px 12px",
                        color: "#667eea",
                        cursor: "pointer",
                        fontWeight: 600,
                        transition: "all 0.2s ease",
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.background =
                          "rgba(102, 126, 234, 0.5)";
                        e.currentTarget.style.color = "white";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.background =
                          "rgba(102, 126, 234, 0.3)";
                        e.currentTarget.style.color = "#667eea";
                      }}
                    >
                      <FontAwesomeIcon icon={faUserPlus} /> Join
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default UGGridCentreLowerLayout;
